export const makeApiUrl = (path: String): string =>
  `https://api.4boss.com.br/precificador${path}`;
